<template>
  <!-- تب‌های بخش پکیج پشتیبانی؛ هر تب یک صفحه و آدرس جدا دارد -->
  <nav class="support-tabs" aria-label="بخش‌های پکیج پشتیبانی">
    <router-link
      v-for="item in items"
      :key="item.route"
      :to="{ name: item.route }"
      class="support-tabs__item"
      active-class="support-tabs__item--active"
      exact
    >
      <feather-icon :icon="item.icon" size="16" />
      <span class="support-tabs__text">{{ item.title }}</span>
      <span v-if="counts[item.key] !== undefined" class="support-tabs__count">{{ counts[item.key] }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "SupportPackageTabs",
  props: {
    // تعداد هر تب، مثلا { waiting: 3 }؛ تبی که عدد ندارد بدون شمارنده نمایش داده می‌شود
    counts: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      items: [
        { key: "waiting", title: "در انتظار اتصال", icon: "ClockIcon", route: "apps-support-packages-waiting" },
        { key: "active", title: "تماس‌های در حال انجام", icon: "PhoneCallIcon", route: "apps-support-packages-active" },
        { key: "report", title: "گزارش پشتیبان‌ها", icon: "BarChart2Icon", route: "apps-support-packages-report" },
        { key: "comments", title: "نظرات اساتید", icon: "MessageSquareIcon", route: "apps-support-packages-comments" },
      ],
    };
  },
};
</script>

<style scoped>
.support-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  padding: 6px;
  border-radius: 14px;
  background: #f3f2f7;
}

.support-tabs__item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 12px;
  border-radius: 10px;
  color: #5e5873;
  font-weight: 600;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.support-tabs__item:hover {
  background: rgba(115, 103, 240, 0.08);
  color: #7367f0;
}

.support-tabs__item--active,
.support-tabs__item--active:hover {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.75));
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}

.support-tabs__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.support-tabs__count {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  font-size: 12px;
}

.support-tabs__item--active .support-tabs__count {
  background: #fff;
}

.dark-layout .support-tabs {
  background: #161d31;
}

.dark-layout .support-tabs__item {
  color: #b4b7bd;
}

/* موبایل: دو تب در هر ردیف، آیکن بالای عنوان */
@media (max-width: 575.98px) {
  .support-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .support-tabs__item {
    flex-direction: column;
    gap: 2px;
    padding: 6px 4px;
    font-size: 11px;
  }
}
</style>
